export enum SettingsFormSubmissionMode {
  TEST = 'TEST',
  CONTINUE = 'CONTINUE',
  EDIT = 'EDIT'
}
